import axios from "axios";
import api from "../../config/api";

export default () => {
  const userToken = localStorage.getItem("user-token");
  let headers = {};
  if (userToken != null) {
    headers["Authorization"] = "JWT " + userToken;
  }
  return axios.create({
    baseURL: api.base_url,
    headers
  });
};
